// The video editor (components/Editor), one file per area so its strings are
// written and reviewed in pieces: t('editor.rve.<area>.<key>')
import shell from './shell.pt.js';
import text from './text.pt.js';
import layers from './layers.pt.js';
import timeline from './timeline.pt.js';

export default { shell, text, layers, timeline };
